import { Display } from "../../../../base/styles";
import clsx from "clsx";

export const SelectDisplay = ({ title, value, className, onChange }:{
    title: string,
    value?: Display,
    className?: string,
    onChange: (value?: Display) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as Display;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={Display.None}>None</option>
                <option value={Display.Inline}>Inline</option>
                <option value={Display.InlineBlock}>Inline Block</option>
                <option value={Display.Block}>Block</option>
                <option value={Display.Table}>Table</option>
                <option value={Display.TableCell}>Table Cell</option>
                <option value={Display.TableRow}>Table Row</option>
                <option value={Display.Flex}>Flex</option>
                <option value={Display.InlineFlex}>Inline Flex</option>
            </select>
        </div>
    )
}